import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

function Blanchisserie() {
  const navigate = useNavigate();

  const [encaissements, setEncaissements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [devise, setDevise] = useState("");

  const chargerEncaissements = async () => {
    try {
      setLoading(true);

      const params = {};

      if (search.trim()) {
        params.search = search.trim();
      }

      if (devise) {
        params.devise = devise;
      }

      const response = await api.get("/blanchisserie", { params });

      setEncaissements(response.data.data || []);
    } catch (error) {
      console.error(
        "Erreur chargement blanchisserie:",
        error
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    chargerEncaissements();
  }, [devise]);

  const handleSearch = (e) => {
    e.preventDefault();
    chargerEncaissements();
  };

  const totalUSD = encaissements
    .filter((item) => item.devise === "USD")
    .reduce((sum, item) => sum + Number(item.montant), 0);

  const totalCDF = encaissements
    .filter((item) => item.devise === "CDF")
    .reduce((sum, item) => sum + Number(item.montant), 0);

  const formatMoney = (montant) =>
    Number(montant).toLocaleString("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const formatDate = (date) =>
    new Date(date).toLocaleString("fr-FR", {
      dateStyle: "short",
      timeStyle: "short",
    });

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Les Prestations</h1>
          <p style={styles.subtitle}>
            Encaissements et recettes de diverses Prestations
          </p>
        </div>

        <button
          style={styles.primaryButton}
          onClick={() =>
            navigate("/blanchisserie/nouveau")
          }
        >
          + Nouvel encaissement
        </button>
      </div>

      {/* TOTAUX */}
      <div style={styles.cards}>

        <div style={styles.card}>
          <div style={styles.cardLabel}>
            Revenus USD
          </div>

          <div style={styles.cardValue}>
            {formatMoney(totalUSD)} USD
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardLabel}>
            Revenus CDF
          </div>

          <div style={styles.cardValue}>
            {formatMoney(totalCDF)} CDF
          </div>
        </div>

        <div style={styles.card}>
          <div style={styles.cardLabel}>
            Encaissements
          </div>

          <div style={styles.cardValue}>
            {encaissements.length}
          </div>
        </div>

      </div>

      {/* FILTRES */}
      <form
        onSubmit={handleSearch}
        style={styles.filters}
      >

        <input
          type="text"
          placeholder="Rechercher un numéro ou un client..."
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
          style={styles.input}
        />

        <select
          value={devise}
          onChange={(e) =>
            setDevise(e.target.value)
          }
          style={styles.select}
        >
          <option value="">Toutes les devises</option>
          <option value="USD">USD</option>
          <option value="CDF">CDF</option>
        </select>

        <button
          type="submit"
          style={styles.secondaryButton}
        >
          Rechercher
        </button>

      </form>

      {/* TABLE */}
      <div style={styles.tableContainer}>

        {loading ? (
          <div style={styles.message}>
            Chargement...
          </div>
        ) : encaissements.length === 0 ? (
          <div style={styles.message}>
            Aucun encaissement trouvé.
          </div>
        ) : (
          <table style={styles.table}>

            <thead>
              <tr>
                <th style={styles.th}>Numéro</th>
                <th style={styles.th}>Date</th>
                <th style={styles.th}>Client</th>
                <th style={styles.th}>Montant</th>
                <th style={styles.th}>Mode</th>
                <th style={styles.th}>Action</th>
              </tr>
            </thead>

            <tbody>

              {encaissements.map((item) => (

                <tr key={item.id}>

                  <td style={styles.td}>
                    <strong>{item.numero}</strong>
                  </td>

                  <td style={styles.td}>
                    {formatDate(
                      item.date_encaissement
                    )}
                  </td>

                  <td style={styles.td}>
                    {item.client_nom ||
                      "Client de passage"}
                  </td>

                  <td style={styles.td}>
                    <strong>
                      {formatMoney(item.montant)}{" "}
                      {item.devise}
                    </strong>
                  </td>

                  <td style={styles.td}>
                    {item.mode_paiement}
                  </td>

                  <td style={styles.td}>

                    <button
                      style={styles.actionButton}
                      onClick={() =>
                        navigate(
                          `/blanchisserie/${item.id}`
                        )
                      }
                    >
                      Voir
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>
        )}

      </div>

    </div>
  );
}

const styles = {
  page: {
    padding: "24px",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "24px",
    gap: "20px",
  },

  title: {
    margin: 0,
    fontSize: "28px",
    fontWeight: "700",
  },

  subtitle: {
    margin: "6px 0 0",
    color: "#6b7280",
  },

  primaryButton: {
    border: "none",
    borderRadius: "8px",
    padding: "11px 18px",
    cursor: "pointer",
    fontWeight: "600",
    background: "#1d4ed8",
    color: "#fff",
  },

  cards: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    marginBottom: "24px",
  },

  card: {
    background: "#fff",
    borderRadius: "12px",
    padding: "20px",
    boxShadow:
      "0 2px 8px rgba(0,0,0,0.08)",
  },

  cardLabel: {
    color: "#6b7280",
    fontSize: "14px",
    marginBottom: "8px",
  },

  cardValue: {
    fontSize: "22px",
    fontWeight: "700",
  },

  filters: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap",
  },

  input: {
    flex: 1,
    minWidth: "250px",
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
  },

  select: {
    padding: "10px 12px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    background: "#fff",
  },

  secondaryButton: {
    padding: "10px 16px",
    border: "1px solid #d1d5db",
    borderRadius: "8px",
    background: "#fff",
    cursor: "pointer",
  },

  tableContainer: {
    background: "#fff",
    borderRadius: "12px",
    overflow: "auto",
    boxShadow:
      "0 2px 8px rgba(0,0,0,0.08)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    textAlign: "left",
    padding: "13px",
    background: "#f8fafc",
    borderBottom:
      "1px solid #e5e7eb",
    fontSize: "13px",
  },

  td: {
    padding: "13px",
    borderBottom:
      "1px solid #f1f5f9",
    fontSize: "14px",
  },

  actionButton: {
    border: "none",
    borderRadius: "6px",
    padding: "7px 12px",
    background: "#f1f5f9",
    cursor: "pointer",
  },

  message: {
    padding: "40px",
    textAlign: "center",
    color: "#6b7280",
  },
};

export default Blanchisserie;